import { render, staticRenderFns } from "./CommercialPropertyListDetails.vue?vue&type=template&id=5bbbe436&"
import script from "./CommercialPropertyListDetails.vue?vue&type=script&lang=js&"
export * from "./CommercialPropertyListDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports